import "./modernizr";
import "details-polyfill";
import svg4everybody from "svg4everybody";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "./modules";

svg4everybody();
